import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import { Grid, Typography, Button } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';



import LoginForm from '../components/LoginForm';
import UserRoles from '../components/UserRoles';


import userActionsV2 from '../actions/userActionsV2';
import { LoginRequest } from '../types/LoginRequest';
import { UserData } from '../types/UserData';
import _ from "lodash";
import config from '../../../config/config';
import { LoginRequestV2 } from '../types/LoginRequestV2';
import LoginWithPassword from '../components/LoginWithPassword';
import LoginWithOTP from '../components/LoginWithOTP';
import ForgotPasswordWithOTP from '../components/ForgotPasswordWithOTP';
import LoginV2 from './LoginV2';
import UnregisterDevice from '../components/UnregisterDevice';
import { string } from 'prop-types';
import MyPATDialog from '../../common/MyPATDialog';
import loginSources, { loginVia } from '../constant/loginConstant';


const styles = (theme: Theme) => createStyles({
    loginLeft: {
        // background: 'url("/assets/img/login_background.svg")',
        // backgroud: "linear-gradient(180deg, #DDF0FF 27.43%, #E8FF98 120.61%)",
        backgroundImage: 'linear-gradient(180deg, #DDF0FF 27.43%, #E8FF98 120.61%)',
        height: '100vh',
        overflow: 'hidden',
        paddingTop: '50px',
        textAlign: 'center',
        '& h2':{
            fontWeight: 600,
        }
    },
    demoButton: {
        background: theme.palette.common.white,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
        borderRadius: `${theme.spacing.unit * 7}px`,
        marginTop: `${theme.spacing.unit * 7}px`,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.193756)',
    },
    loginLeftImg:{
        transform: 'scale(.9)',
        paddingBottom: 20,
        display: 'block',
        margin: '0 auto',
    },
    dialogHeading: {
        fontSize: '24px',
        fontWeight: 600,
        color: '#333',
        margin: '20px 0 30px 0',
    },
    dialogBoldText: {
        fontWeight: 700,
    },
    primaryBtn:{
        backgroundColor: '#FD8619',
        fontSize: 14,
        fontWeight: 600,
        color: '#fff',
        padding: '12px 39px',
        marginBottom: '15px!important',
        '&:hover':{
          backgroundColor: '#FD8619',
        }
    },
    cancleBtn:{
        fontSize: 14,
        fontWeight: 600,
        color: '#FD8619',
        padding: '12px 39px',
        marginBottom: '15px!important',    
    },
    dialogMsgBox:{
        display: 'flex',
        alignItems: 'flex-start',
        padding: '16px 15px',
        borderRadius: '4px',
        background: '#FEF4F4',
        margin: '10px 0',
        '& img': {
            width: '35px',
            marginRight: '15px',
        },
        '& p': {
            color: '#333',
            fontSize: '16px',
            fontWeight: 400,
            textAlign: 'left',
            margin: '0',
        }
    },
    // customContainer:{
    //     display: 'grid',
    //     gridTemplateColumns: '45% 55%',
    // }
});

//@ts-ignore
interface LoginProps extends WithStyles<typeof styles> {
    classes: any,
    userData: UserData,
    login: Function,
    setSelectedRole: Function,
    history: any,
    location: any,
    setAlreadyLoggedInData: Function,
}

interface LoginState {
    loginRequestData: any,
}

class Login extends Component<LoginProps, LoginState>{

    constructor(props: LoginProps, state: LoginState) {
        super(props);
        const location = _.get(props, 'location.search');
        const searchParams = new URLSearchParams(location);
        const source = searchParams.get('source') || '';
        if (loginSources.includes(source) && searchParams.get('token')) {
            const tokenData = JSON.stringify({
                authenticatedUser: {
                    authToken: searchParams.get('token'),
                    authTokenSource: searchParams.get('source'),
                }
            });
            localStorage.setItem('actionType', searchParams.get('actionType') || '');
            localStorage.setItem(config.localStorageKey, tokenData);
            props.history.replace({ search: '' });
            loginVia.GLORIFIRE === source ? this.handleStudentLoginAutoSubmit() : this.handleTeacherLoginAutoSubmit();
        }
        this.state = {
            loginRequestData: {},
        }

        this.loginSuccess = this.loginSuccess.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleforceLogIn = this.handleforceLogIn.bind(this);
        this.renderView = this.renderView.bind(this);
    }

    loginSuccess(loginRequest: LoginRequestV2) {
        const fingerprintId = localStorage.getItem('visitorId') || '';
        this.setState({loginRequestData: loginRequest});
        loginRequest = {
            ...loginRequest,
            fingerprintId,
            authenticateUserDevice: true
        }
        this.props.login(loginRequest);
    }

    handleTeacherLoginAutoSubmit() {
        // sending empty email pass, not req here
        this.props.login({}, true);
    }

    handleStudentLoginAutoSubmit() {
        this.props.login({}, false, true);
    }


    componentDidMount() {
    }

    handleModalClose() {
        this.props.setAlreadyLoggedInData(null);
    }

    handleforceLogIn() {
        const loginRequest: LoginRequestV2 = {
            ...this.state.loginRequestData,
            logoutActiveDevice: true,
        }
        this.loginSuccess(loginRequest);
    }

    renderView() {
        const { userData, setSelectedRole } = this.props;
        const backFromSetPass = localStorage.getItem('backToForgot');
        if (userData.isAuthenticated && !userData.selectedRole) {
            return (<UserRoles roles={(userData.authenticatedUser ? userData.authenticatedUser.roles : [])} setSelectedRole={setSelectedRole} />)
        }
        if (backFromSetPass) {
            userData.isAuthenticated = false
        }
        if (userData.isAuthenticated) {
            if (((this.props.location || {}).data || {}).loginVia === 'forgot') {
                if (this.props.location.data.isPasswordSet === 'true') {
                    return (<Redirect to={{pathname: '/set-password',state:{data:this.props.location.data}}} />)
                }
            } else if (((this.props.location || {}).data || {}).loginVia === 'password' || ((this.props.location || {}).data || {}).loginVia === 'otp') {
                if (this.props.location.data.isPasswordSet === 'false') {
                    return (<Redirect to={{pathname: '/set-password',state:{data: this.props.location.data.isPasswordSet}}} />)
                } else {
                    if (((this.props.location || {}).data || {}).isPasswordSet === 'true') {
                        if (localStorage.getItem('isFirstUser') !== 'true') {
                            return (<Redirect to='/mylibrary' />)
                        }
                    }
                }
            } else {
                //@ts-ignore
            if(userData.authenticatedUser.roles[0].roleId && userData.authenticatedUser.roles[0].roleId.role){
                return (<Redirect to='/mylibrary' />)
            } else {
                let promise = new Promise((resolve, reject)=>{
                    setTimeout(() => {
                          resolve(true)  
                    }, 500);
                })
                if(promise){
                    if (((this.props.location || {}).data || {}).isPasswordSet === 'false' || localStorage.getItem('isFirstUser') === 'true') {
                        return (<Redirect to={{pathname: '/set-password',state:{data: 'false'}}} />);
                    } else {
                        return (<Redirect to='/mylibrary' />);
                    }
                }
            }
            }
        } else {
            let authData : any = localStorage.getItem('tempAuthToken');
            authData = JSON.parse(authData);
            let loginSource:any = localStorage.getItem(config.localStorageKey);
            loginSource = loginSource && JSON.parse(loginSource);
            const authenticatedUser = loginSource && loginSource.authenticatedUser;
            const isAuthenticated = authenticatedUser && authenticatedUser.authTokenSource && authenticatedUser.authToken;
            if (userData.unregisteredDevicesData !== null && !((this.props.location || {}).data || {}).showUnregisterDeviceOtp && !isAuthenticated) {
                return (<UnregisterDevice loginData={{data:this.props.location.data}} />)
            } else if (userData.unregisteredDevicesData !== null && ((this.props.location || {}).data || {}).showUnregisterDeviceOtp && !isAuthenticated) {
                return (<LoginWithOTP loginData={{data:this.props.location.data}} />)
            } else if (((this.props.location || {}).data || {}).loginVia === 'otp') {
                return (<LoginWithOTP loginData={{data:this.props.location.data}} loginSuccess={this.loginSuccess} />)
            } else if (((this.props.location || {}).data || {}).loginVia === 'password') {
                return (<LoginWithPassword loginData={{data:this.props.location.data}} loginSuccess={this.loginSuccess} />)
            } else if (((this.props.location || {}).data || {}).loginVia === 'forgot') {
                return (<ForgotPasswordWithOTP loginData={{data:this.props.location.data}} loginSuccess={this.loginSuccess} />)
            } else if (localStorage.getItem('isFirstUser') === 'true' && authData !== null) {
                return (<Redirect to={{pathname: '/set-password',state:{data: 'false'}}} />);
            } else {
                return (<LoginV2 />)
            }
            
        }
    }

    render() {

        const { classes } = this.props;
        const { userData } = this.props;

        return (
            <>
            {this.renderView()}
            <MyPATDialog
                dialogOpen={userData.alreadyLoggedInDeviceData}
                dialogHasActions={true}
                dialogHeading={false}
                isAlignCenter={true}
                customButtonVariant="withoutBorderCloseIcon"
                isCustomBackground={false}
                isborderDialogAction={true}
                otherDialogProps={{
                  fullWidth: false,
                  maxWidth: "sm",
                }}
                customDialogActions={
                  <>
                    <div className={classes.txtRight}>
                      <Button className={classes.cancleBtn} onClick={()=>{this.handleModalClose()}}>
                        No
                      </Button>
                      <Button className={classes.primaryBtn} onClick={()=>{this.handleforceLogIn()}}>
                        Yes
                      </Button>
                    </div>
                     </>
                }
                  >
                <Grid
                container
                    direction="row"
                    justify="center">
                      <div className="dialogBody">
                        <img src="/assets/img/manage-device/sign-in-logo.svg" alt="Remove Device" />
                        <h4 className={classes.dialogHeading}>Sign In</h4>
                        <p className="deviceInfo">
                            You are already signed in through <span className={classes.dialogBoldText}>{userData.alreadyLoggedInDeviceData && userData.alreadyLoggedInDeviceData.loggedInDevice.device.model}</span>. At any given time, you can access Glorifire Authors Platform through only one of your registered devices.
                        </p>
                        <div className={classes.dialogMsgBox}>
                            <img src="/assets/img/manage-device/remove-device.svg" alt="Remove Device" />
                            <p>Continuing further will automatically log you out of your previous device.</p>
                        </div>
                        <p className="deviceInfo">Are you sure you want to continue?</p>
                      </div>
                    </Grid>
            </MyPATDialog>
            {/* // <Grid container>
            //     <Grid item xs={6} className={classes.loginLeft}>
            //         <Typography variant="h6" component="h2">Focus on what you do best and leave <br /> everything else to us</Typography>
            //         <Typography variant="subtitle1" component="h4">Academic content authoring and management tool</Typography>
            //         <Button className={classes.demoButton}>Watch Demo</Button>
            //         <img className={classes.loginLeftImg} src="/assets/img/login-background-bg.png" alt="" />
            //     </Grid>
            //     <Grid item xs={6}>
                    {this.renderView()}
            //     </Grid>
            // </Grid> */}
            </>
        );
    }

}


const mapStateToProps = (state: any) => {
    return {
        userData: state.loginData.userData
    };
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    login: userActionsV2.login,
    setSelectedRole: userActionsV2.setSelectedRole,
    setAlreadyLoggedInData: userActionsV2.setAlreadyLoggedInData,
}, dispatch)



// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login));